import { Avatar, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { upperCase } from 'lodash';
import PropTypes from 'prop-types';
import stc from 'string-to-color';

const FacilityAvatar = ({ rxPrefix, facilityName, facilityState }) => {
  const bgColor = stc(upperCase(rxPrefix));
  const theme = useTheme();

  return (
    <Tooltip arrow placement='right' title={`Filling at ${facilityName} - ${facilityState}`}>
      <Avatar
        sx={{
          bgcolor: bgColor,
          color: theme.palette.getContrastText(bgColor || '#000'),
          width: theme.spacing(3),
          height: theme.spacing(3),
          fontSize: '1em',
        }}
        alt={rxPrefix}
      >
        {rxPrefix}
      </Avatar>
    </Tooltip>
  );
};

FacilityAvatar.propTypes = {
  rxPrefix: PropTypes.string.isRequired,
  facilityName: PropTypes.string.isRequired,
  facilityState: PropTypes.string.isRequired,
};

export default FacilityAvatar;
